import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH } from "../variables";
import {
  StaffCompanyDigitalPayslipRequest,
  StaffCompanyDigitalPayslipResponse,
} from "../model/company-digital-payslip.model";

@Injectable({ providedIn: "root" })
export class StaffCompanyDigitalPayslipsService {
  private readonly url: string;

  constructor(
    private readonly http: HttpClient,
    @Inject(BASE_PATH) organizationBasePath: string,
  ) {
    this.url = `${organizationBasePath.replace(/\/$/, "")}/api/v1/company-digital-payslips`;
  }

  list(): Observable<StaffCompanyDigitalPayslipResponse[]> {
    return this.http.get<StaffCompanyDigitalPayslipResponse[]>(this.url);
  }

  getByCompanyId(
    companyId: number,
  ): Observable<StaffCompanyDigitalPayslipResponse> {
    return this.http.get<StaffCompanyDigitalPayslipResponse>(
      `${this.url}/company/${companyId}`,
    );
  }

  update(
    companyId: number,
    request: StaffCompanyDigitalPayslipRequest,
  ): Observable<StaffCompanyDigitalPayslipResponse> {
    return this.http.put<StaffCompanyDigitalPayslipResponse>(
      `${this.url}/company/${companyId}`,
      request,
    );
  }
}
